import { propertyRoutes } from '@services';
import { propertyPayloadType } from '@interface';
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
    baseURL: API_BASE_URL,
});
export const propertylist = async ({ bbl, format, endpoint }: propertyPayloadType) => {
    try {
        return await api.get(`${propertyRoutes.property}/${bbl}/${endpoint}/?format=${format}&${endpoint === 'acrisrealmasters' ? 'financing=true':''}`);
    } catch (error) {
        throw error;
    }
};


export const propertyInfo = async (bbl: string) => {
    try {
        return await api.get(`${propertyRoutes.property}/${bbl}/?format=json&summary=true`);
    } catch (error) {
        throw error;
    }
};

export const propertyDatasets = async () => {
    try {
        return await api.get(`${propertyRoutes.dataset}/?format=json`);
    } catch (error) {
        throw error;
    }
};
